import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../components/HomePage/HomePage'
import DonationPage from '../components/DonationPage/DonationPage'
import ConfiguratorPage from '../components/ConfiguratorPage/ConfiguratorPage'
import Organ from '../components/Organ'
import {Power2, TweenMax} from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/pate-werden',
      name: 'Jetzt eine Klangpatenschaft abschließen',
      component: ConfiguratorPage
    },
    {
      path: '/spenden',
      name: 'Spende für den Erhalt der Orgeln',
      component: DonationPage
    },
    {
      path: '/paten',
      name: 'Paten',
      component: Organ
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  let scrollDuration = (window.scrollY / 1000) > 2 ? 2 : (window.scrollY / 1000)
  TweenMax.to(window, scrollDuration, {
    scrollTo: {y: 0, x: 0},
    ease: Power2.easeOut,
    onComplete: () => {
      next()
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js